










































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import Pagination from '@morpheus/utils/admin-vue/mixins/pagination'
import UserInventoryList from '../components/UserInventoryList.vue'
import { addInventoryToUser, deleteInventoryItemById, fetchInventoryListByUserId } from '../services/inventory-client'
import { EntitlementShowData, EntitlementsListData, InventoryAddData } from '../types'
import UserInventoryAddForm from '../components/UserInventoryAddForm.vue'

export default mixins(Pagination).extend({
  name: 'UserInventory',
  components: {
    UserInventoryList,
    UserInventoryAddForm
  },
  props: {
    userId: {
      required: true,
      type: String
    },
    pagerConfig: {
      required: false,
      type: Object,
      default: () => ({ newRoute: 'push' })
    }
  },
  data () {
    return {
      isLoading: true,
      clearForm: false,
      showAddInventoryForm: false,
      headers: [
        { text: 'Codename', value: 'codename', sortable: false },
        { text: 'Created At', value: 'created_at', sortable: false },
        { text: 'Actions', value: '_id', align: 'center', sortable: false }
      ],
      itemsList: []
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchInventoryListByUserId(this.userId, `?limit=${this.rowsPerPage}&offset=${this.paginationOffset}`)
        .then(({ items, total }: EntitlementsListData) => {
          this.itemsList.splice(0, this.itemsTotal)
          items.forEach((item: EntitlementShowData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
          this.itemsTotal = total
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.checkPagination()
          this.isLoading = false
          this.$store.commit('global/setLoading', false)
        })
    },
    onSubmit (entitlementId: string, inventoryData: InventoryAddData) {
      this.isLoading = true
      addInventoryToUser(this.userId, entitlementId, inventoryData)
        .then(() => {
          this.clearForm = true
          this.$store.commit('global/addNotification', {
            text: 'You successfully added new inventory to user!',
            type: 'success'
          })
          this.fetchItems()
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
          this.showAddInventoryForm = false
        })
    },
    onClearForm () {
      this.clearForm = false
    },
    onCancel () {
      this.showAddInventoryForm = false
    },
    onDeleteUserInventory (id: string) {
      this.isLoading = true
      deleteInventoryItemById(id)
        .then(() => {
          this.fetchItems()
          this.$store.commit('global/addNotification', {
            text: 'You successfully deleted inventory!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
})
